import { SideNavigationMenu } from "@/components/shared";
import { isManager, isMemberOfMainOrganization } from "@/utils/authentication";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const SettingsLayout = () => {
  const { t } = useTranslation();

  const navLinks = [
    { route: "notifications", text: t("settings.navlinks.notifications")},
    { route: "bidrules", text: t("settings.navlinks.bidrule")},
    { route: "marginrules", text: t("settings.navlinks.marginrule") },
    { route: "users", text: t("settings.navlinks.users") },
    { route: "advancedcostparameters", text: t("settings.navlinks.advancedcosts") },
    { route: "configurations", text: t("settings.navlinks.configurations") },
    { route: "configadmins", text: t("settings.navlinks.configadmins") },
    ...(isManager() && isMemberOfMainOrganization()
      ? [{ route: "billing", text: t("settings.navlinks.billing") }]
      : [])
  ];

  return (
    <div>
      <div className="flex select-none">
        {/* Navigation Menu */}
        <SideNavigationMenu navLinks={navLinks} headerTitle={t("components:header.profile.settings")} />

        {/* Form */}
        <div className="grow h-screen overflow-y-auto">
          <Outlet/>
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout;
